// Canonical enum values used on the wire + the friendly section headings
// per the current feature spec.
export const CATEGORIES = [
    { value: "Open Incident", label: "Open Incidents" },
    { value: "Pending Change", label: "Pending Changes and Transports" },
    { value: "Job to Monitor", label: "Jobs to Monitor" },
    { value: "Monitoring Watch", label: "Monitoring Watch Items" },
    { value: "Scheduled Activity", label: "Scheduled Activities" },
    { value: "Escalation", label: "Escalations in Progress" },
    { value: "Callback or Follow up", label: "Callbacks and Follow-ups" },
    { value: "Workaround or Note", label: "Workarounds and Notes" },
];

export const CATEGORY_LABEL = Object.fromEntries(
    CATEGORIES.map((c) => [c.value, c.label]),
);

export const PRIORITIES = ["P1", "P2", "P3", "P4", "Not applicable"];
export const ITEM_STATUSES = ["Open", "Closed"];
